import { Button } from "@/components/ui/button";
import { ArrowRight, Check, X } from "lucide-react";
import { Link } from "react-router-dom";

interface ActionButtonsProps { timeframe: string; isEditing: boolean; onSave: () => void; onCancel: () => void; }

const ActionButtons = ({ timeframe, isEditing, onSave, onCancel }: ActionButtonsProps) => (
  <>
    <div className="flex flex-wrap gap-4 pt-2">
      <Button className="gap-2" asChild>
        <Link to="/consultation" className="flex items-center gap-2">
          Get Started <ArrowRight className="h-4 w-4" />
        </Link>
      </Button>
    </div>
    {isEditing && (
      <div className="flex justify-end mt-4 gap-2">
        <Button variant="destructive" size="sm" onClick={e => { e.stopPropagation(); onCancel(); }}><X className="h-4 w-4 mr-1" /> Cancel</Button>
        <Button variant="default" size="sm" onClick={e => { e.stopPropagation(); onSave(); }}><Check className="h-4 w-4 mr-1" /> Save</Button>
      </div>
    )}
  </>
);

export default ActionButtons;
